import type { SpecialtyModel } from '../app/types/lookup.type.ts';
import baseApi from './meeting-md-api-slice.ts';

const specialtiesApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchSpecialties: builder.query<SpecialtyModel[], void>({
      query: () => `/specialty`,
    }),
    fetchAccountSpecialties: builder.query<SpecialtyModel[], void>({
      query: () => `/specialty/AllAccount`,
    }),
  }),
});

export const { useFetchSpecialtiesQuery, useFetchAccountSpecialtiesQuery } = specialtiesApi;
